var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-content"},[_c('main',{staticClass:"l-editor"},[_vm._t("default")],2),_c('messages',{staticClass:"c-messages--l-editor"}),_c('modals')],1)}
var staticRenderFns = []

export { render, staticRenderFns }